import SI from "./enum.js";

export function showAlert(alert) {
	return (dispatch) => {
		dispatch({ type: SI.ALERT_IN, payload: alert });
	};
}

export function hideAlert(index) {
	return (dispatch) => {
		dispatch({ type: SI.ALERT_OUT, payload: index });
	};
}

export function toggleAuthPopup(isOpen, authType) {
	return {
		type: SI.TOGGLE_AUTH_POPUP,
		payload: { isOpen, authType },
	};
}

export function setStaticWarning(warning) {
	return (dispatch) => {
		const payload = { priority: 0, ...warning };
		dispatch({ type: SI.SET_STATIC_WARNING, payload });
	};
}

export function clearStaticWarning(options = {}) {
	return (dispatch) => {
		dispatch({ type: SI.CLEAR_STATIC_WARNING, payload: options });
	};
}
